import { useTranslation } from 'react-i18next';
import React, { useCallback } from 'react';
import { Avatar, Button, Card, Col, Divider, Row, Space, Tag, Typography } from 'antd';
import { MailOutlined, SafetyOutlined, SolutionOutlined } from '@ant-design/icons';
import './AccountPage.scss';
import useAuthStore from '../../stores/auth.store';
import { UserRole } from '../../gen/proto/api/gateway/v1/user_pb';
import { userRoleLabel } from '../../utils/mapTranslationEnums';
import ChangePasswordModal from '../../components/account/ChangePasswordModal';
import { useNavigate } from 'react-router-dom';
import { signInPath } from '../../routes';

const { Title, Text } = Typography;
const AccountPage = () => {
  const name = useAuthStore((state) => state.username);
  const email = useAuthStore((state) => state.email);
  const role = useAuthStore((state) => state.role);
  const navigate = useNavigate();
  const nameInitials = name
    .trim()
    .split(/\s+/)
    .map((word) => word[0])
    .join('')
    .toUpperCase();

  const handleLogout = useCallback(() => {
    const authStore = useAuthStore.getState();
    authStore.logout();
    navigate(signInPath);
  }, [navigate]);

  const { t } = useTranslation('account');
  return (
    <>
      <br />
      <Space size={'middle'}>
        <SolutionOutlined className={'AccountPage__icon'} />
        <Title level={1} className={'AccountPage__title'}>
          {t('profile')}
        </Title>
      </Space>
      <br />
      <div className={'AccountPage'}>
        <Card styles={{ body: { padding: 0 } }} className={'AccountPage__content'}>
          <div className={'AccountPage__card'}>
            <div className={'AccountPage__card__userPersonalInfo'}>
              <Avatar size={80}>{nameInitials}</Avatar>
              <div className={'AccountPage__card__personalInfo'}>
                <Text className={'AccountPage__card__personalInfo__name'}>{name}</Text>
                <Text className={'AccountPage__card__personalInfo__email'}>
                  <MailOutlined />
                  {email}
                </Text>
              </div>
            </div>
            <div className={'AccountPage__card__status'}>
              <div className={'AccountPage__card__status__info'}>
                <Tag className={'AccountPage__card__status__info__role'} icon={<SafetyOutlined />}>
                  {userRoleLabel(role ?? UserRole.UNSPECIFIED)}
                </Tag>
              </div>
              <Button danger onClick={handleLogout}>
                {t('logout')}
              </Button>
            </div>
          </div>
        </Card>
        <Card>
          <div>
            <div className={'AccountPage__details__headerArea'}>
              <Text className={'AccountPage__details__title'}>{t('dataInfo')}</Text>
              <ChangePasswordModal />
            </div>
            <Divider variant={'dashed'} />
            <Row align={'middle'}>
              <Col span={4}>
                <Text className={'AccountPage__detail_data__name'}>{t('name')}</Text>
              </Col>
              <Col span={20}>
                <Text>{name}</Text>
              </Col>
            </Row>
            <Divider variant={'dashed'} />
            <Row align={'middle'}>
              <Col span={4}>
                <Text className={'AccountPage__detail_data__name'}>{t('mail')}</Text>
              </Col>
              <Col span={20}>
                <Text>{email}</Text>
              </Col>
            </Row>
            <Divider variant={'dashed'} />
            <Row align={'middle'}>
              <Col span={4}>
                <Text className={'AccountPage__detail_data__name'}>{t('role')}</Text>
              </Col>
              <Col span={20}>
                <Text>{userRoleLabel(role ?? UserRole.UNSPECIFIED)}</Text>
              </Col>
            </Row>
          </div>
        </Card>
      </div>
    </>
  );
};

export default AccountPage;
